import { TrackJS } from '@common/utils/'
import * as FavoriteMiddleWare from '@common/components/src/favorite/FavoriteMiddleWare'

const middlewares = [
    FavoriteMiddleWare.favoriteMiddleware,
    TrackJS.TrackJSLogger
];
export default middlewares;
